import { GetAccountsResponse } from '@iwoca/lapi-client/edge';

type TCashflows = NonNullable<
    NonNullable<GetAccountsResponse['data']>['accounts'][number]['cashflows']
>;

export const getLastRepaymentDate = (cashflows: TCashflows) => {
    return cashflows
        .filter((cf) => cf.type === 'repayment')
        .sort((a, b) => {
            return (
                new Date(b.datetime!).getTime() -
                new Date(a.datetime!).getTime()
            );
        })[0].datetime;
};

export const getMostRecentRepaymentAmount = (cashflows: TCashflows) => {
    return cashflows
        .filter((cf) => cf.type === 'repayment')
        .sort((a, b) => {
            return (
                new Date(b.datetime!).getTime() -
                new Date(a.datetime!).getTime()
            );
        })[0].amount;
};
